import { Col, Form, Input, Label, Row } from "reactstrap";
import { City, ShippingClass, ZipCode } from "../../../../../../constants";
import { useAppDispatch } from "../../../../../../reduxToolkit/hooks";
import { setFormValue } from "../../../../../../reduxToolkit/reducers/eCommerce/addProductSlice";
import WeightDimensionInputs from "./WeightDimensionInputs";
import { ShippingClassList, StateList } from "../../../../../../data/applications/ECommerce";

// This component handles additional product options, including shipping details.
const Shipping = () => {
  const dispatch = useAppDispatch();

  return (
    <div className="meta-body">
      <Form>
        <Row className="g-3 custom-input">
          <Col xs="12">
            <Row className="gx-xl-3 gx-md-2 gy-md-0 g-2">
              <Col xs="12">
                <Label> Where can I pick up my order? </Label>
              </Col>
              <Col md="4" sm="6">
                <Input type="number" placeholder={`${ZipCode} (10001)`} name="zipCode" onChange={(e) => dispatch(setFormValue({ name: "zipCode", value: e.target.value }))} />
              </Col>
              <Col md="4" sm="6">
                <Input type="text" name="city" placeholder={City} onChange={(e) => dispatch(setFormValue({ name: "city", value: e.target.value }))} />
              </Col>
              <Col md="4">
                <Input type="select" defaultValue={"State"} name="state" onChange={(e) => dispatch(setFormValue({ name: "state", value: e.target.value }))}>
                  {/* Mapping through StateList which renders a list of states */}
                  {StateList.map((item, index) => (<option key={index}>{item}</option>))}
                </Input>
              </Col>
            </Row>
          </Col>
          <WeightDimensionInputs />
          <Col xs="12">
            <Row>
              <Col xs="12"><Label>{ShippingClass}</Label></Col>
              <Col md="12">
                <Input type="select" name="inputState" defaultValue={"Basic Shipping"} onChange={(e) => dispatch(setFormValue({ name: "inputState", value: e.target.value }))}>
                  {/* Mapping through ShippingClassList which renders a list of shipping types */}
                  {ShippingClassList.map((item, index) => (<option key={index}>{item}</option>))}
                </Input>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Shipping;